import { render, staticRenderFns } from "./NavIcon.vue?vue&type=template&id=c0f612a6&scoped=true&"
import script from "./NavIcon.vue?vue&type=script&lang=js&"
export * from "./NavIcon.vue?vue&type=script&lang=js&"
import style0 from "./NavIcon.vue?vue&type=style&index=0&id=c0f612a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f612a6",
  null
  
)

component.options.__file = "NavIcon.vue"
export default component.exports